<template>
  <div class="flow-record-page dark-theme">
    <!-- 主内容区 -->
    <div class="login-record-container">
      <!-- 流量充值记录卡片 -->
      <div class="section-card">
        <div class="card-header">
          <a-icon type="wallet" class="card-icon" />
          <h3 class="card-title">{{ translate('flowRecord.title') }}</h3>
        </div>

        <!-- 流量充值记录表格 -->
        <a-table
          :columns="columns"
          :data-source="datalist"
          rowKey="id"
          :loading="dataLoading"
          :pagination="pagination"
          @change="handlePaginationChange"
          size="middle"
          class="dark-table"
        >
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlowRecordPage',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
    columns() {
      return [
        {
          title: this.translate('flowRecord.column.createTime'),
          dataIndex: 'creatTime',
          key: 'creatTime',
          width: 200,
        },
        {
          title: this.translate('flowRecord.column.beforeFlow'),
          dataIndex: 'beforeflow',
          key: 'beforeflow',
          width: 150,
        },
        {
          title: this.translate('flowRecord.column.changeFlow'),
          dataIndex: 'changeflow',
          key: 'changeflow',
          width: 150,
          customRender: (text) => {
            // 根据流量变化值显示不同颜色
            const isPositive = Number(text) > 0;
            return {
              children: isPositive ? `+${text}` : text,
              attrs: {
                style: {
                  color: isPositive ? '#52c41a' : '#f5222d',
                  fontWeight: '500'
                }
              }
            };
          }
        },
        {
          title: this.translate('flowRecord.column.afterFlow'),
          dataIndex: 'afterflow',
          key: 'afterflow',
          width: 150,
        },
      ];
    },
  },
  data() {
    return {
      datalist: [],
      rowKey: 'index',
      dataLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total) => {
          return this.translate('flowRecord.pagination.total', { total });
        },
      },
      timer: '', // 定时器名称
    };
  },
  methods: {
    // 国际化翻译方法
    translate(key, params = {}) {
      const lang = this.currentLanguage;
      const translations = {
        'flowRecord.title': lang === 'zh' ? '流量充值记录' : 'Flow Recharge Record',
        'flowRecord.column.createTime': lang === 'zh' ? '创建时间' : 'Create Time',
        'flowRecord.column.beforeFlow': lang === 'zh' ? '充值前流量' : 'Before Flow',
        'flowRecord.column.changeFlow': lang === 'zh' ? '充值流量' : 'Change Flow',
        'flowRecord.column.afterFlow': lang === 'zh' ? '充值后流量' : 'After Flow',
        'flowRecord.pagination.total': lang === 'zh' ? `共 ${params.total} 条记录` : `Total ${params.total} records`,
        'flowRecord.message.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
      };
      return translations[key] || key;
    },
    // 登录状态检查
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear()
          this.$message.warning(this.translate('flowRecord.message.loginWarning'))
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    // 启动定时检查
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000)
    },
    // 获取流量充值记录数据
    fetchFlowRecordData() {
      this.dataLoading = true;
      this.$request.get('/ums/getFlowAddList', {
        params: {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.datalist = res.data.data.list;
          this.pagination.total = res.data.data.total;
        }
      })
        .catch((e) => {
          console.error('获取流量充值记录失败:', e);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    // 处理分页变化
    handlePaginationChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.fetchFlowRecordData();
    },
  },
  mounted() {
    this.fetchFlowRecordData();
    this.start();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style scoped lang="less">
// 深色主题全局样式
.dark-theme {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  color: #ffffff;
  min-height: 100vh;
}

// 主容器样式
.login-record-container {
  padding: 20px;
  // max-width: 1600px;
  margin: 0 auto;
}

// 卡片通用样式
.section-card {
  background: rgba(30, 41, 59, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(21, 129, 198, 0.2);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  color: #ffffff !important;

  &:hover {
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(21, 129, 198, 0.2);
}

.card-icon {
  font-size: 20px;
  color: #1581c6;
  background: rgba(21, 129, 198, 0.1);
  padding: 8px;
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
}

// 深色表格样式
.dark-table {
  background: transparent !important;
  color: #ffffff !important;

  :deep(.ant-table) {
    background: transparent !important;
  }

  :deep(.ant-table-thead > tr > th) {
    background: rgba(51, 65, 85, 0.8) !important;
    border-bottom: 1px solid rgba(21, 129, 198, 0.2) !important;
    color: rgba(255, 255, 255, 0.8) !important;
    font-weight: 700 !important;
    font-size: 14px;
    padding: 16px 12px;
  }

  :deep(.ant-table-tbody > tr) {
    background: transparent !important;
    border-bottom: 1px solid rgba(21, 129, 198, 0.1) !important;
  }

  :deep(.ant-table-tbody > tr > td) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 14px;
    padding: 16px 12px;
    background: rgba(30, 41, 59, 0.3) !important;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: rgba(21, 129, 198, 0.2) !important;
  }

  :deep(.ant-pagination) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item) {
    background: rgba(51, 65, 85, 0.8) !important;
    border: 1px solid rgba(21, 129, 198, 0.3) !important;
  }

  :deep(.ant-pagination-item a) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item-active) {
    background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%) !important;
    border-color: transparent !important;
  }

  :deep(.ant-pagination-item-active a) {
    color: #ffffff !important;
  }

  // 空状态样式优化
  :deep(.ant-empty) {
    color: rgba(255, 255, 255, 0.5) !important;
    background: rgba(30, 41, 59, 0.3) !important;
    border: 1px solid rgba(21, 129, 198, 0.2) !important;
    border-radius: 8px;
    padding: 40px 20px !important;
    margin: 20px 0 !important;
  }

  :deep(.ant-empty-image) {
    margin-bottom: 16px !important;
  }

  :deep(.ant-empty-image svg) {
    fill: rgba(255, 255, 255, 0.2) !important;
    stroke: rgba(255, 255, 255, 0.3) !important;
  }

  :deep(.ant-empty-description) {
    color: rgba(255, 255, 255, 0.5) !important;
    font-size: 14px !important;
  }

  :deep(.ant-table-placeholder) {
    border: none !important;
    background: transparent !important;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .login-record-container {
    padding: 16px;
  }

  .card-header {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  .dark-table {
    :deep(.ant-table) {
      font-size: 12px;
    }

    :deep(.ant-table-thead > tr > th) {
      padding: 12px 8px;
    }

    :deep(.ant-table-tbody > tr > td) {
      padding: 12px 8px;
    }
  }
}
</style>